import { jsx as B } from "react/jsx-runtime";
import { useController as N } from "react-hook-form";
import { isDefined as s } from "./types3.mjs";
import { NumericField as b } from "./index94.mjs";
const L = ({
  control: d,
  name: r,
  defaultValue: m,
  rules: a,
  shouldUnregister: u,
  helperText: f,
  onChange: o,
  onBlur: n,
  value: i,
  ...p
}) => {
  const {
    field: { onChange: c, onBlur: h, ref: g, value: v, ...C },
    fieldState: { error: l }
  } = N({
    name: r,
    control: d,
    rules: a,
    defaultValue: m,
    shouldUnregister: u
  }), t = i !== void 0 ? i : v, F = (e) => {
    c(e), s(o) && o(e);
  }, x = (e) => {
    h(), s(n) && n(e);
  };
  return /* @__PURE__ */ B(
    b,
    {
      id: r,
      error: !!l,
      helperText: f || l?.message,
      ref: g,
      onChange: F,
      onBlur: x,
      value: t ?? "",
      InputLabelProps: t ? { shrink: !0 } : void 0,
      ...p,
      ...C
    }
  );
};
export {
  L as FormNumericField
};
//# sourceMappingURL=index95.mjs.map
